import { apiClient } from './client'
import type { ApiResponse, PlayCheckResponse } from '@/types'

export const playApi = {
  checkAccess: async (quetureId: string, wb?: string): Promise<PlayCheckResponse> => {
    const params: Record<string, string> = { quetureId }
    if (wb) params.wb = wb
    const response = await apiClient.get<ApiResponse<PlayCheckResponse>>(
      '/play/check',
      { params }
    )
    return response.data.data!
  },
}
